import fetchHTTP from 'Utils/fetchHTTP';

const getCards = () => fetchHTTP('/v1/protected/customer/sources?', {
  method: 'GET',
});

const getAmountAvailable = () => fetchHTTP('/v1/protected/customer/amounts', {
  method: 'GET',
});

const getAnalyticsCustomer = () => fetchHTTP('/v1/protected/analytics/customer ', {
  method: 'GET',
});

/**
 * @typedef { import('Models/Applications/Customer').CustomerType } CustomerType
 */

/**
 * Get the customer type
 * @returns { Promise<{ data: { user_type: CustomerType }, status: string }> }
 */
export const getConsumerType = () => fetchHTTP('/v1/protected/customer/type', {
  method: 'GET',
});

/* eslint-disable max-len */
/**
 * @typedef { 'filling' | 'scoring' | 'validating' | 'approving' | 'offering' | 'signing' | 'transfer' } ApplicationStatus
 */
/* eslint-enable max-len */
/**
 * @typedef { 'cash_installments' | 'instore_consumer' } PaymentType
 */

/**
 * @typedef { Object } PendingApplicationData
 * @property { boolean } is_pending
 * @property { ApplicationStatus } status
 * @property { string } merchant_name
 * @property { 'online' | 'instore' } channel
 * @property { PaymentType } payment_type
 */

/**
 * @returns { Promise<{ status: string, data: PendingApplicationData }> }
 */
export const getPendingApplication = () => fetchHTTP('/v1/protected/customer/pending_application', {
  method: 'GET',
});

export const updateCustomerProperty = (data) => fetchHTTP('/v1/protected/customer/property', {
  data,
  method: 'PUT',
});

export {
  getAmountAvailable,
  getCards,
  getAnalyticsCustomer,
};
